import React, { useState }  from 'react'
import { Col, Button } from 'react-bootstrap'
import { Search } from 'react-bootstrap-icons'
import useClientLocation from '../../../hooks/use-client-location'
import CLIENT_ENDPOINTS from '../../../constants/client-endpoints'

const ViewButton = ({
    itemId
}) => {
    const { toLocation } = useClientLocation()

    return (
        <Button
            variant='primary'
            className='btn-circle btn-md'
            onClick={ () => toLocation(CLIENT_ENDPOINTS.REPORT.replace(':reportId', itemId))}
        >
            <Search size={30} />
        </Button>
    )
}

export default ViewButton